/**
 * @module web/store
 * @private
 */

import { cache } from "../persistence/cache";
import { getCookieByName } from "../../utils/cookiesUtils";


let token = null;

/**
 * Update the session token with the given newToken. This token will be saved in memory and also in a local cache for a
 * period of 4 hours.
 * @param {String} newToken A JWT obtained from a backend call
 */
const updateToken = function(newToken) {
  token = newToken;
  if (this.localCache && this.localCache.auth) {
    cache.set(
      "token",
      { token },
      {
        database: "auth",
        expiresIn: this.tokenExpirationTime
      }
    );
  }
};

/**
 * Returns the current session token, if any. The token will be searched in memory first and local cache as second
 * option.
 * @returns {string} A found JWT or null if none memory nor cache have a valid token.
 */
const getToken = async function() {
  let cachedToken = null;
  if (this.localCache && this.localCache.auth) {
    cachedToken = await cache.get("token", { database: "auth" });
  }
  if (!token && cachedToken && cachedToken.token) {
    token = cachedToken.token;
  }
  if(!token && !cachedToken && this.jwtCookie) {
    token = getCookieByName(this.jwtCookie.name);
  }
  return token;
};

export default { updateToken, getToken };
